import React, { useRef, useEffect, useState } from "react"
import styles from "./styles"
import { withStyles } from "@material-ui/core/styles"
import * as Yup from "yup"
import { Formik, Form } from "formik"
import ReusableFormControl from "../../../../components/ReusableFormControl"
import MaskedMobileInput from "../../../../components/MaskedMobileInput"
import GooglePlacesAutocomplete from "react-google-places-autocomplete"
import { geocodeByPlaceId } from "react-google-places-autocomplete/dist/utils/googleGeocodesHelper"
const primaryContantSchema = Yup.object().shape({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  address: Yup.string().required("Required"),
  email: Yup.string()
    .email()
    .required("Required"),
  phone: Yup.string()
    .required("Required")
    .length(14, "Please enter a mobile phone number")
})

const extractFromAddress = (components, type, part = "long_name") => {
  for (var i = 0; i < components.length; i++) {
    for (var j = 0; j < components[i].types.length; j++) {
      if (components[i].types[j] === type) return components[i][part]
    }
  }
  return ""
}

const Step2PrimaryContact = ({ classes, data }) => {
  const formRef = useRef()
  const { setFormRef, formSubmit, setFormData, formState } = data
  const [addressTouched, setAddressTouched] = useState(false)
  useEffect(() => {
    setFormRef(formRef)
  }, [])
  return (
    <Formik
      innerRef={formRef}
      initialValues={{
        firstName: formState.firstName,
        lastName: formState.lastName,
        address: formState.address ? formState.address.address : "",
        email: formState.email,
        phone: formState.phone
      }}
      validationSchema={primaryContantSchema}
      onSubmit={() => {
        setTimeout(() => {
          formSubmit()
        })
      }}
    >
      {formikProps => {
        const handleChange = formikProps.handleChange
        formikProps.handleChange = e => {
          handleChange(e)
          setFormData(e)
        }
        return (
          <Form ref={formRef}>
            <ReusableFormControl
              name={"firstName"}
              label="Contact First Name"
              formikProps={formikProps}
              inputClass={classes.inputReusableFormControl}
              inputProps={{ autoComplete: "false" }}
              inputLabelClass={classes.labelTextColor}
            />
            <ReusableFormControl
              name={"lastName"}
              label="Contact Last Name"
              formikProps={formikProps}
              inputClass={classes.inputReusableFormControl}
              inputProps={{ autoComplete: "off" }}
              inputLabelClass={classes.labelTextColor}
            />
            <GooglePlacesAutocomplete
              suggestionsClassNames={{
                container: classes.locationSuggestionContainer,
                suggestion: classes.locationSuggestion,
                suggestionActive: classes.locationSuggestionActive
              }}
              placeholder={""}
              initialValue={formState.address ? formState.address.address : ""}
              loader={<div style={{ display: "none" }} />}
              debounce={300}
              onSelect={place => {
                let placeObj = {
                  address: place.description,
                  placeId: place.place_id,
                  city: null,
                  state: null,
                  zip: null,
                  country: null,
                  street: null
                }
                geocodeByPlaceId(place.place_id)
                  .then(results => {
                    const streetNumber = extractFromAddress(
                      results[0].address_components,
                      "street_number"
                    )
                    const route = extractFromAddress(
                      results[0].address_components,
                      "route"
                    )
                    const city = extractFromAddress(
                      results[0].address_components,
                      "locality"
                    )
                    const state = extractFromAddress(
                      results[0].address_components,
                      "administrative_area_level_1",
                      "short_name"
                    )
                    const zip = extractFromAddress(
                      results[0].address_components,
                      "postal_code"
                    )
                    const country = extractFromAddress(
                      results[0].address_components,
                      "country"
                    )

                    const place = {
                      street: `${streetNumber} ${route}`,
                      city,
                      state,
                      zip,
                      country
                    }
                    placeObj = { ...placeObj, ...place }
                  })
                  .catch(err => {
                    console.log(err)
                  })
                  .finally(() => {
                    formikProps.setFieldValue("address", place.description)
                    setFormData({
                      target: {
                        value: placeObj,
                        name: "address"
                      }
                    })
                  })
              }}
              renderInput={props => {
                if (
                  props.value === "" &&
                  formState.address &&
                  formState.address.address &&
                  !addressTouched
                ) {
                  props.value = formState.address.address
                }
                return (
                  <ReusableFormControl
                    name="address"
                    label="Street Address"
                    formikProps={formikProps}
                    inputLabelClass={classes.labelTextColor}
                    inputProps={{
                      onKeyUp: e => {
                        // formikProps.setFieldValue("address", "")
                        setAddressTouched(true)
                      },
                      ...props
                    }}
                  />
                )
              }}
            />
            <ReusableFormControl
              name={"email"}
              label="Contact Email"
              formikProps={formikProps}
              inputClass={classes.inputReusableFormControl}
              inputLabelClass={classes.labelTextColor}
            />
            <ReusableFormControl
              name="phone"
              label="Contact Phone"
              formikProps={formikProps}
              inputLabelClass={classes.labelTextColor}
              inputProps={{
                inputComponent: MaskedMobileInput
              }}
            />
          </Form>
        )
      }}
    </Formik>
  )
}

export default withStyles(styles)(Step2PrimaryContact)



// WEBPACK FOOTER //
// ./src/pages/OrganizationSignUp/steps/Step2PrimaryContact/index.jsx